import './style/styles-training-list.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/training-list'

Object.values(features).forEach(createComponent)
